import { EventEmitter, Injectable, Output } from '@angular/core';
import { Router } from '@angular/router';
import { IIdentityResultModel } from 'src/app/models/interfaces/seguridad/IIdentityResultModel';
import { IUsuarioRegistrarModel } from 'src/app/models/interfaces/seguridad/IUsuarioRegistrarModel';
import { SessionModel } from 'src/app/models/seguridad/SesionModel';
import { UsuarioRegistrarModel } from 'src/app/models/seguridad/UsuarioRegistrarModel';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  @Output() fireIsLoggedIn: EventEmitter<UsuarioRegistrarModel> = new EventEmitter<UsuarioRegistrarModel>();
  
  private localStorageService;
  private currentSession: SessionModel | null = null;

  constructor(private router: Router) {
    this.localStorageService = localStorage;
    this.currentSession = this.loadSessionData()
  }

  loadSessionData(): SessionModel | null{
    let sessionStr : string | null = this.localStorageService.getItem('currentUser');
    let token : string | null = this.localStorageService.getItem('token');
    if(sessionStr === null){
      return null;
    }
    else{
      let session: SessionModel = new SessionModel();
      session.token = token ? token : '';
      session.user = <UsuarioRegistrarModel>JSON.parse(sessionStr);
      return session;
    }
  }

  setCurrentToken(model: IIdentityResultModel){
    this.localStorageService.setItem('token', model.accessToken);
  }

  setCurrentSession(session: SessionModel): void {
    this.currentSession = session;
    this.localStorageService.setItem('currentUser', JSON.stringify(session.user)); 

    this.fireIsLoggedIn.emit(session.user);
  }

  getEmitter() { 
    return this.fireIsLoggedIn; 
  } 

  getCurrentSession(): SessionModel | null {
    return this.currentSession;
  }

  isAuthenticated(): boolean {
    return (this.getCurrentToken() != null) ? true : false;
  }

  getCurrentUser(): IUsuarioRegistrarModel {
    let session: SessionModel | null = this.getCurrentSession();    
    return (session && session.user) ? session.user : new UsuarioRegistrarModel();
  };

  getCurrentToken(): string | null {
    var session = this.getCurrentSession();
    return (session && session.token) ? session.token : null;
  }

  removeCurrentSession(): void {
    // this.localStorageService.removeItem('currentUser');
    // this.localStorageService.removeItem('token');
    this.localStorageService.clear();
    this.fireIsLoggedIn.emit(new UsuarioRegistrarModel());
    this.currentSession = null;
  }

  logout(): void{
    this.removeCurrentSession();
    this.router.navigate(['/login']);
  }
}
